export default "__VITE_ASSET__DcIfn$7t__"